/**
 * @description: router name
 */
export const enum RouterEnum {
	HOME_PAGE_PATH = '/_home_',
	LOGIN_PAGE_PATH = '/login',
	PAGE_403 = '403',
	PAGE_404 = '404',
	PAGE_500 = '500',
}
